import { SelectPicker } from "rsuite";
import useModule from "../../../hooks/useModule";
import EditPrefillMenu from "../../CRM/EditPrefillMenu";
import FilterInput from "../../SavedFilters/FilterInput";
import { QrCodeConfig } from "./AddViewDrawer";
import { PrefillPair } from "../../../types/GlobalInterfaces";

interface Props {
  moduleAPIName: string;
  qrCodeConfig: QrCodeConfig;
  setQrCodeConfig: React.Dispatch<React.SetStateAction<QrCodeConfig | null>>;
  disabled?: boolean;
}

export default function QRScannerSettings({
  moduleAPIName,
  qrCodeConfig,
  setQrCodeConfig,
  disabled,
}: Props) {
  const { module } = useModule(moduleAPIName);

  return (
    <div>
      <h4 className="mb-0 mt-2">QR Search Field</h4>
      <div className="small mb-2">
        Choose a field to match/search against after scanning the users QR code.
        Must be a UNIQUE field!
      </div>
      <SelectPicker
        disabled={disabled}
        size="sm"
        block
        data={module?.Fields?.filter((f: any) => f?.Unique) || []}
        labelKey="Name"
        valueKey="APIName"
        onChange={(searchField: any) =>
          setQrCodeConfig((prev) => ({
            ...prev!,
            SearchField: searchField || "",
          }))
        }
        value={qrCodeConfig?.SearchField}
        placeholder="Select Field"
      />
      <h4 className="mb-0 mt-4">Fields To Update</h4>
      <div className="small mb-2">
        Select the fields you'd like to update on a successful scan
      </div>
      {/* @ts-ignore */}
      <EditPrefillMenu
        module={module}
        //   originalModule={} TODO:
        prefillPairs={qrCodeConfig?.FieldsToUpdate || []}
        onChange={(newPairs: PrefillPair[]) =>
          setQrCodeConfig((prev) => ({ ...prev!, FieldsToUpdate: newPairs }))
        }
        toggleEditing={() => {}}
        showVariables={true}
        //   variableIdentifiers = null, // provide array of id's for variables you want
        editOnly={true}
        //   customVariableData = null,
        disabledFields={[]} // Array of FieldAPINames to be disabled from adding
      />
      <hr className="mt-4 mb-0" />
      <h4 className="mb-0 mt-4">Record Requirements</h4>
      <div className="small mb-2">
        Setup requirements a matched record must have, for it's fields to be
        updated.
      </div>
      <FilterInput
        disabled={disabled}
        currentModule={module}
        setQuery={(query: any) => {
          setQrCodeConfig((prev) => ({
            ...prev!,
            RecordConditions: query?.Filters || [],
          }));
        }}
        query={{ Filters: qrCodeConfig?.RecordConditions || [] }}
        fallbackMessage="No Conditions Added"
        smallText="Click the box above to create record requirements"
        moduleAPIName={moduleAPIName}
        showVariables={true}
        // @ts-ignore
        onClear={() =>
          setQrCodeConfig((prev) => ({
            ...prev!,
            RecordConditions: [],
          }))
        }
      />
    </div>
  );
}
